import Language from '../../../../../v2/lang/language';

export default (paymentType, siteCode = '') => {
  const label = 'checkout.payment.method.field.label.billing.use.delivery.address';
  
  if (siteCode) {
    if (Language.doesTranslationExist(`${label}.${paymentType}.${siteCode}`)) {
      return `${label}.${paymentType}.${siteCode}`;
    }
    
    if (Language.doesTranslationExist(`${label}.${siteCode}`)) {
      return `${label}.${siteCode}`;
    }
  }
  
  return Language.doesTranslationExist(`${label}.${paymentType}`) ? `${label}.${paymentType}` : label;
};
